/** "mm:ss" (or "h:mm:ss") for game seconds. */
export function clock(seconds: number): string {
  const s = Math.max(0, Math.floor(seconds));
  const h = Math.floor(s / 3600);
  const m = Math.floor((s % 3600) / 60);
  const pad = (n: number) => String(n).padStart(2, "0");
  return h > 0 ? `${h}:${pad(m)}:${pad(s % 60)}` : `${pad(m)}:${pad(s % 60)}`;
}

/** One formatter, made once (toLocaleString makes one a call, and the top
 *  bar formats dozens of numbers a frame). */
const whole = new Intl.NumberFormat("en-US", { maximumFractionDigits: 0 });

export function int(n: number): string {
  return whole.format(Math.round(n));
}

/** "1 unit", "3 units": `noun` as a plural ("units", or a design's name,
 *  "Engineers"), made singular for one by dropping its last "s". */
export function count(n: number, noun: string): string {
  const one = n === 1 && /[^s]s$/i.test(noun) ? noun.slice(0, -1) : noun;
  return `${whole.format(n)} ${one}`;
}

export function pct(part: number, whole: number): string {
  return whole > 0 ? `${Math.round((100 * part) / whole)}%` : "–";
}

export function bytes(n: number): string {
  if (n >= 1e9) return `${(n / 1e9).toFixed(1)} GB`;
  if (n >= 1e6) return `${(n / 1e6).toFixed(1)} MB`;
  if (n >= 1e3) return `${(n / 1e3).toFixed(0)} kB`;
  return `${n} B`;
}

export function el<K extends keyof HTMLElementTagNameMap>(
  tag: K,
  attrs: Record<string, string> = {},
  ...children: (Node | string)[]
): HTMLElementTagNameMap[K] {
  const e = document.createElement(tag);
  for (const [k, v] of Object.entries(attrs)) {
    if (k === "class") e.className = v;
    else if (k === "style") e.style.cssText = v;
    else e.setAttribute(k, v);
  }
  e.append(...children);
  return e;
}

export function $(id: string): HTMLElement {
  const e = document.getElementById(id);
  if (!e) throw new Error(`missing #${id}`);
  return e;
}

/** A labelled horizontal bar. */
export function bar(fraction: number, color: string, label: string): HTMLElement {
  const fill = el("div", { style: `width:${Math.max(0, Math.min(1, fraction)) * 100}%;background:${color}` });
  return el("div", { class: "bar" }, fill, el("span", {}, label));
}
